// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","leftSide":"Footer_leftSide__Vm-2Y","rightSide":"Footer_rightSide__Pf1ic","copy":"Footer_copy__nbk1i","socials":"Footer_socials__bqeqA"};